import { getLink } from '../../../apollo-links'
import { apolloClient } from '../../../ApolloProvider'
import { store } from '../../../store'
import { localStorageKey } from '../../../utils/localStorageKey'

enum LoginErrorMessage {
  Unauthorized = 'Unauthorized',
  UserLockedOut = 'UserLockedOut',
}

enum LoginErrorTranslateKey {
  wrongCredentials = 'messages:warnings.wrongCredentials',
  lockedAccount = 'messages:warnings.lockedAccount',
  serverError = 'messages:warnings.serverError',
}

export const storeDataAfterLogin = async (
  jwtToken: string,
  isFirstLogin: boolean
): Promise<void> => {
  localStorage.setItem(localStorageKey.token, jwtToken)
  apolloClient.setLink(getLink())
  await new Promise((res) => setTimeout(res, 100))
  await apolloClient.resetStore()
  store.dispatch.auth.setIsFirstLogin(isFirstLogin)
}

export const getLoginErrorTranslateKey = (
  errorMessage?: string
): LoginErrorTranslateKey => {
  switch (errorMessage) {
    case LoginErrorMessage.Unauthorized:
      return LoginErrorTranslateKey.wrongCredentials
    case LoginErrorMessage.UserLockedOut:
      return LoginErrorTranslateKey.lockedAccount
    default:
      return LoginErrorTranslateKey.serverError
  }
}
